import Axios from 'axios'
import store from './index'
import {createBasicAuthConfig} from '../util/api'

const defaultState = () => ({
  isModalOpened:false
})

export default{
  namespaced:true,
  state: defaultState(),
  mutations:{
    openModal(state){
      state.isModalOpened = true
    },
    closeModal(state){
      state.isModalOpened = false
    },
    reset(state){
      Object.assign(state, defaultState())
    }
  },
  actions:{
    async shareCollection(bigStuff, reqBody){
      const SERVER_ADDRESS = this._vm.$config[process.env.NODE_ENV].SERVER_ADDRESS
      const API = this._vm.$config[process.env.NODE_ENV].API
      const url = SERVER_ADDRESS + API.SHARE_COLLECTION
      const json = JSON.stringify(reqBody)
      const config = createBasicAuthConfig(
        store.state.authentication.token
      )
      config.headers['Content-Type'] = 'application/json'
      
      let result = {}
      await Axios.post(
        url, json, config
      ).then((resp)=>{
        result = resp.data
      }).catch((err)=>{
        result = err.response.data
      })
      return result
    },
    async renameCollection(bigStuff, reqBody){
      const SERVER_ADDRESS = this._vm.$config[process.env.NODE_ENV].SERVER_ADDRESS
      const API = this._vm.$config[process.env.NODE_ENV].API
      const url = SERVER_ADDRESS + API.RENAME_COLLECTION
      const json = JSON.stringify(reqBody)
      const config = createBasicAuthConfig(
        store.state.authentication.token
      )
      config.headers['Content-Type'] = 'application/json'
      
      let result = {}
      await Axios.post(
        url, json, config
      ).then((resp)=>{
        result = resp.data
      }).catch((err)=>{
        result = err.response.data
      })
      return result
    },
    async deleteCollection(bigStuff, reqBody){
      const SERVER_ADDRESS = this._vm.$config[process.env.NODE_ENV].SERVER_ADDRESS
      const API = this._vm.$config[process.env.NODE_ENV].API
      const url = SERVER_ADDRESS + API.DELETE_COLLECTION
      const json = JSON.stringify(reqBody)
      const config = createBasicAuthConfig(
        store.state.authentication.token
      )
      config.headers['Content-Type'] = 'application/json'
      
      let result = {}
      await Axios.post(
        url, json, config
      ).then((resp)=>{
        result = resp.data
      }).catch((err)=>{
        result = err.response.data
      })
      return result
    },
  }
}